import React, { useState } from "react";
import { Navbar, Nav, Modal, Button, Badge } from "react-bootstrap";
import { ReactComponent as Logo } from "../../assets/SenseAbleIcon.svg";
import { faBell } from "@fortawesome/free-solid-svg-icons";
import "./UserCSS/NavbarComponent.css"
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logoutUser } from "../../redux/slices/authSlice"; // Import logout action
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCircle } from "@fortawesome/free-solid-svg-icons"; // Import the user icon
import toast from "react-hot-toast"; // Import react-hot-toast

function NavbarComponent() {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Access user data from Redux store
  const user = useSelector((state) => state.auth.user);
  // Get alert count of unacknowledged alerts from Redux (example assumes alerts state)
  const alerts = useSelector((state) => state.alerts.alerts || []);
  const unacknowledgedAlertsCount = alerts.filter(
    (alert) => !alert.acknowledged
  ).length;

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleLogout = async () => {
    // Perform logout operations
    localStorage.removeItem("access_token");
    dispatch(logoutUser()); // Update Redux store

    // Show toast notification using react-hot-toast
    toast.success("Logged out successfully");

    // Redirect to login after a short delay
    setTimeout(() => {
      navigate("/login", { replace: true });
    }, 1000);
  };

  return (
    <>
      <Navbar bg="dark" variant="dark" expand="lg" className="px-3">
        <Navbar.Brand href="#home">
          <Logo />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link as={Link} to="/useralerts" style={{ display: "inline-flex", alignItems: "center" }}>
              <span style={{ position: "relative", display: "inline-block", marginRight: 7 }}>
                <FontAwesomeIcon
                  icon={faBell}
                  className={`bell-alert${unacknowledgedAlertsCount > 0 ? ' bell-alert-animate' : ''}`}
                  style={{ fontSize: "1.2em", verticalAlign: "middle" }}
                />
                {unacknowledgedAlertsCount > 0 && (
                  <Badge
                    bg="danger"
                    pill
                    style={{
                      position: "absolute",
                      top: -6,
                      right: -10,
                      fontSize: "0.7em",
                      padding: "0.15em 0.4em",
                      pointerEvents: "none"
                    }}
                  >
                    {unacknowledgedAlertsCount}
                  </Badge>
                )}
              </span>
              <span style={{ verticalAlign: "middle", fontSize: "1em", fontWeight: 500 }}>Alerts</span>
            </Nav.Link>


            <Nav.Link onClick={handleShow}>Profile</Nav.Link>
            <Nav.Link href="#settings">Settings</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>

      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Profile</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* User Information */}
          {user ? (
            <div className="profile-info text-center">
              {/* User Icon */}
              <FontAwesomeIcon icon={faUserCircle} size="5x" className="mb-3" />
              <p>
                <strong>User ID:</strong> {user.user_id}
              </p>
              <p>
                <strong>Username:</strong> {user.user_name}
              </p>
              <p>
                <strong>Email:</strong> {user.email}
              </p>
              {/* Logout Button inside the Profile Modal */}
              <Button
                variant="danger"
                onClick={handleLogout}
                className="w-100 mt-3"
              >
                Logout
              </Button>
            </div>
          ) : (
            <p>Loading user data...</p>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default NavbarComponent;
